import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

export const ERROR_CODE_LOCK_USER = 22;
export const ERROR_CODE_FROZEN_USER = 23;

export enum FORGOT_PIN_STEP_NAMES {
    FAILED_STEP = 'FAILED_STEP',
    USER_INFO_STEP = 'USER_INFO_STEP',
    SUCCESSFUL_STEP = 'SUCCESSFUL_STEP',
    SECRETS_QUESTION_STEP = 'SECRETS_QUESTION_STEP',
    FORGOT_SECRET_ANSWER_STEP = 'FORGOT_SECRET_ANSWER_STEP',
}

export const FORGOT_PIN_FIELDS = {
    [VALIDATION_FIELDS.firstname]: '',
    [VALIDATION_FIELDS.lastname]: '',
    [VALIDATION_FIELDS.dateOfBirth]: '',
    [VALIDATION_FIELDS.zip]: '',
    [VALIDATION_FIELDS.pin]: '',
    [VALIDATION_FIELDS.verificationAnswer]: ''
};

export const FORGOT_PIN_DATA = {
    question: '',
    actionToken: '',
    parameters: FORGOT_PIN_FIELDS,
    stepName: FORGOT_PIN_STEP_NAMES.USER_INFO_STEP
};
